import { Component, DestroyRef, inject, input, OnInit, signal } from '@angular/core';
import { Breakpoints } from '@angular/cdk/layout';
import { debounceTime, Observable, filter, share, startWith, switchMap } from 'rxjs';
import { FormControl } from '@angular/forms';
import { AcvisService } from '@app/services/acvis.service';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { ParamFilters } from '@app/models/filtermodels/ParamFilters';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ConnectedPosition } from '@angular/cdk/overlay';
import { MediaService } from '@app/services/media.service';

@Component({
    selector: 'clever-roomtype',
    templateUrl: './roomtype.component.html',
    styleUrls: ['./roomtype.component.scss'],
    standalone: false
})
export class RoomtypeComponent implements OnInit {
    mode = input<string>('');
    isBrowser = signal<boolean>(false);
    showModal = signal<boolean>(false);
    focus = signal<boolean>(false);
    zielText = signal<string>('Beliebig');
    searchObj: Observable<any>;
    mySearchControl = new FormControl();
    selectedList = signal<any[]>([]);

    destroyRef = inject(DestroyRef);

    overlaypos: ConnectedPosition[] = [
        {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top',
        }
    ];

    beliebig_zimmer = [
        {
            name: 'Doppelzimmer',
            code: 'DZ',
        },
        {
            name: 'Familienzimmer',
            code: 'FZ',
        },
        {
            name: 'Familiensuite',
            code: 'FS',
        },
        {
            name: 'Suite',
            code: 'SU',
        }
    ];

    constructor(
        protected mediaService: MediaService,
        protected acvisService: AcvisService,
        protected hotelService: HotelFiltersService,
    ) {
    }

    ngOnInit(): void {
        this.initSearchChange();
        this.initFilterSub();
    }

    initSearchChange() {
        const filterShare = this.mySearchControl.valueChanges.pipe(
            startWith(''),
            debounceTime(100),
            filter(value => (typeof value === 'string' && value?.length > 0)),
            share()
        );

        this.searchObj = filterShare.pipe(
            switchMap(value => this.acvisService.request({
                searchValue: value
            }, 'roomTypeListCompletions'))
        );
    }

    initFilterSub() {
        this.hotelService.getfilters$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((filter: ParamFilters) => {
            if (filter?.roomTypeList?.length > 0) {
                if (JSON.stringify(this.selectedList()) !== JSON.stringify(filter?.roomTypeList)) {
                    this.selectedList.set(JSON.parse(JSON.stringify(filter?.roomTypeList)));
                    this.zielText.set(this.selectedList().length + ' Zimmer');
                }
            } else {
                this.zielText.set('Beliebig');
            }
        });
    }

    async openModal() {
        this.showModal.set(true);
        this.focus.set(true);
    }

    async openModalMobile() {
        this.showModal.set(true);
        this.focus.set(true);
    }

    async closeModal() {
        this.showModal.set(false);
        this.mySearchControl.setValue('');
    }

    async closeModalMobile() {
        this.take();
    }

    async clearText() {
        this.mySearchControl.setValue('');
        this.focus.set(false);
        setTimeout(() => {
            this.focus.set(true);
        }, 50);
    }

    selectValue(item) {
        this.mySearchControl.setValue('');
        this.selectedList().push({
            name: item.name,
            code: item.code,
        });
        this.zielText.set(this.selectedList().length + ' Zimmer');
    }

    async removeValue(index) {
        this.selectedList().splice(index, 1);
        this.zielText.set(this.selectedList().length + ' Zimmer');
    }

    async addZimmer(ev, item) {
        ev.stopPropagation();
        const index = this.indexInlist(item);
        if (index >= 0) {
            this.removeValue(index);
        } else {
            this.selectValue(item);
        }
    }

    indexInlist(item): number {
        for (let i = 0; i < this.selectedList().length; i++) {
            if (this.selectedList()[i].code === item?.code) {
                return i;
            }
        }
        return -1;
    }

    isNotInlist(item): boolean {
        for (let i = 0; i < this.selectedList().length; i++) {
            if (this.selectedList()[i].code === item?.code) {
                return false;
            }
        }
        return true;
    }

    removeAllSelected() {
        this.selectedList.set([]);
        this.zielText.set('Beliebig');
    }

    removeFromSelected(k) {
        if (this.selectedList()[k]) {
            this.selectedList().splice(k, 1);
        }
        this.zielText.set(this.selectedList().length > 0 ? this.selectedList().length + '' : 'Beliebig');
    }

    take() {
        this.hotelService.roomTypeListTotal(JSON.parse(JSON.stringify(this.selectedList())));
        this.closeModal();
    }
}
